<div class="leadership-container variant-premium tanuh-themed-page">
  <app-asset-header [config]="headerConfig" variant="tanuh"></app-asset-header>

  <div class="leadership-content">
    <div class="leadership-main">
      <div class="leadership-container-inner">
        <app-leadership-provider
          [providersPagination]="hackathonPagination"
          [showLoadMore]="false"
          [showEngagementMetrics]="false"
          [headingLabel]="'Models Leaderboard'"
          [boardVisualVariant]="'hackathon'"
          [hackathonTrackLabel]="activeHackathonProblemStatementName"
          [hackathonTabs]="hackathonTabs"
          [activeHackathonTrack]="activeHackathonTrack"
          [hackathonMetricColumns]="hackathonMetricColumns"
          [hackathonTableRows]="hackathonLeaderboardRows"
          (hackathonTrackChange)="changeHackathonTrack($event)"
          (downloadHackathonCsv)="downloadActiveHackathonCsv()">
        </app-leadership-provider>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
